import firebase from "firebase";
import "firebase/firestore";

const config = {
  apiKey: "AIzaSyAj1xwXjtp_gAs-2Wtxc9Tri0LsOziGbnc",
  authDomain: "daalgavarmn.firebaseapp.com",
  projectId: "daalgavarmn",
  storageBucket: "daalgavarmn.firebasestorage.app",
  messagingSenderId: "228480643407",
  appId: "1:228480643407:web:ea46f55c1c58f230a6553a",
  measurementId: "G-01ZLZY6VVF"
};

const app = firebase.initializeApp(config);

// firebase utils
const firestore = firebase.firestore;
const db = firebase.firestore();
const auth = firebase.auth();
export const analytics = app.analytics();
const currentUser = auth.currentUser;

var googleProvider = new firebase.auth.GoogleAuthProvider();
googleProvider.addScope("email");

const storage = firebase.storage;
const storageRef = firebase.storage().ref();
const imageStorageFolder = "_schoolImages";
/**
 * Upload a file to Firebase Storage and get download URL
 * @param {string} path - Storage path (e.g., 'videos/my-video.mp4')
 * @param {File|Blob} file - File or Blob to upload
 * @returns {Promise<string>} Download URL of uploaded file
 */
export const uploadToStorage = async (path, file) => {
  try {
    const fileRef = storageRef.child(`${imageStorageFolder}/${path}`);
    const snapshot = await fileRef.put(file);
    const downloadUrl = await snapshot.ref.getDownloadURL();
    return downloadUrl;
  } catch (error) {
    console.error("Error uploading to storage:", error);
    throw error;
  }
};

/**
 * Delete a file from Firebase Storage
 * @param {string} path - Storage path of the file to delete (e.g., 'videos/my-video.mp4')
 * @returns {Promise<void>}
 */
export const deleteFromStorage = async (path) => {
  try {
    const fileRef = storageRef.child(`${imageStorageFolder}/${path}`);
    await fileRef.delete();
    console.log(`File at ${path} deleted successfully.`);
  } catch (error) {
    console.error("Error deleting from storage:", error);
    throw error;
  }
};
export {
  db,
  auth,
  currentUser,
  googleProvider,
  storage,
  storageRef,
  firestore,
};
